/** Parcel-resolved pin faces — prefer atlas cutouts, else article covers. */
export const ATLAS_FACES = {
  'top-wombat': new URL('../assets/images/atlas/top.png', import.meta.url).href,
  'owney': new URL('../assets/images/atlas/owney.png', import.meta.url).href,
  'roxy': new URL('../assets/images/atlas/roxy.png', import.meta.url).href,
  'josiah': new URL('../assets/images/atlas/josiah.png', import.meta.url).href,
  'winnie': new URL('../assets/images/atlas/winnie-the-pooh.png', import.meta.url).href,
  'cher-ami': new URL('../assets/images/atlas/cher-ami.png', import.meta.url).href,
  'rin-tin-tin': new URL('../assets/images/rin-tin-tin.png', import.meta.url).href,
  'bobbie': new URL('../assets/images/atlas/bobbie.png', import.meta.url).href,
  'algonquin': new URL('../assets/images/algonquin_hamlet.webp', import.meta.url).href,
  'minnie-white-city': new URL('../assets/images/minnie_the_cat.png', import.meta.url).href,
  'jim-wonder': new URL('../assets/images/atlas/jim.png', import.meta.url).href,
  'comet': new URL('../assets/images/atlas/comet.png', import.meta.url).href,
  'ming': new URL('../assets/images/atlas/ming.png', import.meta.url).href,
  'snooky': new URL('../assets/images/snooky_of_city_hall.png', import.meta.url).href,
  'tommy-tucker': new URL('../assets/images/tommy_tucker_the_cat.png', import.meta.url).href,
  'reindeer-rockefeller': new URL('../assets/images/the_reindeer_christmas_in_nyc.png', import.meta.url).href,
  'unsinkable-sam': new URL('../assets/images/unsinkable_sam.png', import.meta.url).href,
  'andrew': new URL('../assets/images/atlas/andrew.png', import.meta.url).href,
  'bush': new URL('../assets/images/atlas/bush.png', import.meta.url).href,
  'beauty': new URL('../assets/images/atlas/beauty.png', import.meta.url).href,
  'convoy': new URL('../assets/images/convoy_the_ships_cat.webp', import.meta.url).href,
  'jackie': new URL('../assets/images/atlas/jackie.png', import.meta.url).href,
  'wojtek': new URL('../assets/images/atlas/wojtek.png', import.meta.url).href,
  'pyro': new URL('../assets/images/pyro_the_flying_cat.png', import.meta.url).href,
  'herman': new URL('../assets/images/herman_the_cat.png', import.meta.url).href,
  'lady-moe': new URL('../assets/images/atlas/moe.png', import.meta.url).href,
  'siwash': new URL('../assets/images/atlas/siwash.png', import.meta.url).href,
  'spar': new URL('../assets/images/spar_the_dog.png', import.meta.url).href,
  'judy': new URL('../assets/images/judy.png', import.meta.url).href,
  'sinbad': new URL('../assets/images/atlas/sinbad.png', import.meta.url).href,
  'dee-day': new URL('../assets/images/dee_day_the_cat.png', import.meta.url).href,
  'bing': new URL('../assets/images/atlas/bing.png', import.meta.url).href,
  'pooli': new URL('../assets/images/atlas/pooli.png', import.meta.url).href,
  'myrtle': new URL('../assets/images/myrtle_the_parachick.webp', import.meta.url).href,
  'private-life-cat': new URL('../assets/images/the-private-life-of-a-cat-furrend.png', import.meta.url).href,
  'simon': new URL('../assets/images/atlas/simon.png', import.meta.url).href,
  'koo-koo': new URL('../assets/images/atlas/kookoo.png', import.meta.url).href,
  'reckless': new URL('../assets/images/sergeant_reckless.webp', import.meta.url).href,
  'tibs': new URL('../assets/images/tibs_the_great.webp', import.meta.url).href,
  'gardenia': new URL('../assets/images/gardenia_the_library_cat.webp', import.meta.url).href,
  'branca-cat': new URL('../assets/images/ralph_branca_the_black_cat.png', import.meta.url).href,
  'room-8': new URL('../assets/images/room-8/hewett-3.webp', import.meta.url).href,
  'jet': new URL('../assets/images/atlas/jet.png', import.meta.url).href,
  'opo': new URL('../assets/images/opo_the_dolphin.png', import.meta.url).href,
  'takeshi': new URL('../assets/images/atlas/takeshi.png', import.meta.url).href,
  'laika': new URL('../assets/images/laika_the_dog.png', import.meta.url).href,
  'lady-greyhound': new URL('../assets/images/lady-greyhound/portrait.webp', import.meta.url).href,
  'slippery': new URL('../assets/images/slippery_the_sea_lion.png', import.meta.url).href,
  'sam-fire-pole': new URL('../assets/images/atlas/sam.png', import.meta.url).href,
  'arthur-tv': new URL('../assets/images/arthur_the_tv_cat.png', import.meta.url).href,
  'ham': new URL('../assets/images/atlas/ham.png', import.meta.url).href,
  'andre': new URL('../assets/images/atlas/andre.png', import.meta.url).href,
  'towser': new URL('../assets/images/towser_the_cat.png', import.meta.url).href,
  'petra': new URL('../assets/images/petra_the_tv_dog.png', import.meta.url).href,
  'felicette': new URL('../assets/images/atlas/felicette.png', import.meta.url).href,
  'pickles': new URL('../assets/images/atlas/pickles.png', import.meta.url).href,
  'nasa-cat': new URL('../assets/images/the_falling_cat.png', import.meta.url).href,
  'hoover': new URL('../assets/images/hoover_the_talking_seal.png', import.meta.url).href,
  'beerbohm': new URL('../assets/images/beerbohm_the_theatre_cat.png', import.meta.url).href,
  'smudge': new URL('../assets/images/atlas/smudge.png', import.meta.url).href,
  'baker-taylor': new URL('../assets/images/baker-and-taylor/studio.webp', import.meta.url).href,
  'lala': new URL('../assets/images/lala-the-penguin.png', import.meta.url).href,
  'koko': new URL('../assets/images/koko-the-gorilla.png', import.meta.url).href,
  'larry': new URL('../assets/images/atlas/larry.png', import.meta.url).href,
  'lewis': new URL('../assets/images/atlas/lewis.png', import.meta.url).href,
  'grape-kun': new URL('../assets/images/atlas/grape-kun.png', import.meta.url).href,
  'achilles': new URL('../assets/images/achilles_the_cat.png', import.meta.url).href,
  'minerva': new URL('../assets/images/atlas/minerva.png', import.meta.url).href,
  'bodega': new URL('../assets/images/atlas/bodega-cats-of-nyc.png', import.meta.url).href,
  'mariah': new URL('../assets/images/atlas/mariah.png', import.meta.url).href,
  'neil': new URL('../assets/images/atlas/neil.png', import.meta.url).href,
  'ravi': new URL('../assets/images/ravi-benham/portrait.webp', import.meta.url).href,
  'jimothy': new URL('../assets/images/atlas/jimothy.png', import.meta.url).href,
  'churchill-pub': new URL('../assets/images/atlas/churchill.png', import.meta.url).href,
  'reg': new URL('../assets/images/atlas/reggie.png', import.meta.url).href,
  'carl': new URL('../assets/images/carl_the_firehouse_dog_of_chicago.webp', import.meta.url).href,
  'bobbi-bob': new URL('../assets/images/bobbie_bob.webp', import.meta.url).href,
  'ophelias-books': new URL('../assets/images/ophelias_books.webp', import.meta.url).href,
  'us-open': new URL('../assets/images/us_open.webp', import.meta.url).href,
  'kiri-many': new URL('../assets/images/kiri_many.webp', import.meta.url).href,
  'buddy': new URL('../assets/images/buddy_the_wonderdog.webp', import.meta.url).href,
  'katta-kun': new URL('../assets/images/katta_kun_the_pelican.webp', import.meta.url).href,
  'animals-911': new URL('../assets/images/remembering_the_animals_of_911.webp', import.meta.url).href,
  'roger': new URL('../assets/images/roger/banner.jpg', import.meta.url).href,
  'smokey-bear': new URL('../assets/images/smokey_bear.webp', import.meta.url).href,
  'buddy-deaf': new URL('../assets/images/buddy_the_deaf_dog.webp', import.meta.url).href,
  'beeps': new URL('../assets/images/beeps_ships_cat_of_discovery.webp', import.meta.url).href,
  'tipper': new URL('../assets/images/tipper_the_cat.webp', import.meta.url).href,
  'osborne': new URL('../assets/images/osborne_royal_court.webp', import.meta.url).href,
  'cupboard-maker': new URL('../assets/images/cupboard_maker_books.webp', import.meta.url).href,
  'von-arnim-dogs': new URL('../assets/images/elizabeth-von-arnim-dogs/ingulf-with-daughter-2.jpg', import.meta.url).href,
  'billy-raf': new URL('../assets/images/billy_the_goat.webp', import.meta.url).href,
  'blackie-post-office': new URL('../assets/images/blackie_the_post_office_cat.webp', import.meta.url).href,
  'browser-library': new URL('../assets/images/browser_the_library_cat.webp', import.meta.url).href,
  'crescent-hotel-cats': new URL('../assets/images/crescent_hotel_cats.webp', import.meta.url).href,
};

export const ATLAS_CUTOUT_IDS = new Set([
  'top-wombat',
  'owney',
  'roxy',
  'josiah',
  'winnie',
  'cher-ami',
  'bobbie',
  'judy',
  'sinbad',
  'jim-wonder',
  'comet',
  'ming',
  'andrew',
  'bush',
  'beauty',
  'jackie',
  'wojtek',
  'lady-moe',
  'siwash',
  'bing',
  'pooli',
  'simon',
  'koo-koo',
  'jet',
  'takeshi',
  'sam-fire-pole',
  'ham',
  'andre',
  'felicette',
  'pickles',
  'smudge',
  'larry',
  'lewis',
  'grape-kun',
  'minerva',
  'bodega',
  'mariah',
  'neil',
  'jimothy',
  'churchill-pub',
]);
